import { createSlice } from "@reduxjs/toolkit";
import { getBadResponseErrorMessage } from "../utils/helpers";

const init = {
  leftMenuOpen: true,
  leftSubMenuOpen: "",
  loadingMessage: "",
  errorMessages: null, //Can be a single error string or an array of errors. The ErrorDialgog handles multiple errors
};

const uiSlice = createSlice({
  name: "ui",
  initialState: init,
  reducers: {
    toggleLeftMenu(state) {
      state.leftMenuOpen = !state.leftMenuOpen;
    },

    openLeftMenu(state) {
      state.leftMenuOpen = true;
    },

    closeLeftMenu(state) {
      state.leftMenuOpen = false;
    },

    openLeftSubMenu(state, action) {
      state.leftSubMenuOpen = action.payload;
    },

    closeLeftSubMenu(state) {
      state.leftSubMenuOpen = "";
    },

    setLoading(state, action) {
      state.loadingMessage = action.payload;
    },

    //Accepts a single error string, an array of errors or a response exception
    setErrors(state, action) {
      //If the payload is a response exception, the function uses getBadResponseErrorMessage to extract the error message
      if (typeof action.payload === "object" && !Array.isArray(action.payload)) {
        const errorMessage = getBadResponseErrorMessage(action.payload);

        state.errorMessages = errorMessage;
      } else {
        state.errorMessages = action.payload;
      }
    },
  },
});

export const uiActions = uiSlice.actions;

export default uiSlice.reducer;
